import { Col, Row, Menu, Badge, Typography } from "antd";
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import * as userReducer from "../Redux/User/reducer";
import constants from "../Redux/constants";
import { StyledLink } from "../styled-components/components";
import { useHistory } from "react-router";
import LogoComponent from "../Utilities/LogoComponent";
import moment from "moment";
import { getClientPersonalDetails } from "../Redux/client/reducer";
import { getConsultantPersonalInfo } from "../Redux/Consultant/reducer";
import { getUserDetails } from "../Redux/User/reducer";

import ConsultantHeader from "./ConsultantHeader";
import ClientHeader from "./ClientHeader";

import { BsBell, BsBellFill } from "react-icons/bs";

const Header = (props) => {
  const { userRole, userDetails } = useSelector((state) => state.userStore);

  const {
    getClientDetails,
    getConsultantDetails,
    logOut,
    getAllNotifications,
    readAllNotifications,
    getUserDetails,
  } = props;

  useEffect(() => {
    const fetchDetails = async () => {
      await getUserDetails();
      console.log(userDetails);
    };
    if (!userDetails) {
      // if (userRole === constants.roles.client) {
      //   getClientDetails();
      // } else {
      //   getConsultantDetails();
      // }
      fetchDetails();
    }
    getAllNotifications(0);
  }, [
    getClientDetails,
    getConsultantDetails,
    getAllNotifications,
    userDetails,
    userRole,
    getUserDetails,
  ]);
  const signOut = () => {
    logOut();
  };
  return (
    <Col xs={{ span: 24 }} style={{ background: "#ffffff", padding: "2vh" }}>
      <Row align="middle" justify="space-between">
        <Col xs={{ span: 6 }}>
          <LogoComponent />
        </Col>
        {userRole === constants.roles.client ? (
          <ClientHeader
            signOut={signOut}
            getAllNotifications={getAllNotifications}
            readAllNotifications={readAllNotifications}
          />
        ) : null}
        {userRole === constants.roles.consultant ? (
          <ConsultantHeader
            signOut={signOut}
            getAllNotifications={getAllNotifications}
            readAllNotifications={readAllNotifications}
          />
        ) : null}
      </Row>
    </Col>
  );
};

export const Notifications = (props) => {
  const history = useHistory();
  const { allNotifications } = useSelector((state) => state.userStore);
  const unReadTotal = allNotifications.filter(
    (each) => each.flag === "UNREAD"
  ).length;
  useEffect(() => {
    const fetchAllNotifications = async () => {
      await props.getAllNotifications(0);
    };
    const notificationTimeOut = setInterval(() => {
      fetchAllNotifications();
    }, 30000);
    return () => {
      clearInterval(notificationTimeOut);
    };
  });
  const readNotifications = () => {
    if (unReadTotal > 0) {
      props.readAllNotifications();
    }
  };
  const goToPage = () => {
    history.push("/notifications");
  };
  const formattedDate = (date) => moment.utc(date).from(moment());
  return (
    <Col>
      {allNotifications.length > 0 ? (
        <Menu mode="horizontal" style={{ border: "none" }}>
          <Menu.SubMenu
            onTitleMouseEnter={readNotifications}
            data-testid="view-notifications"
            title={
              <Col>
                <BsBellFill />
                {unReadTotal !== 0 && <Badge count={unReadTotal}></Badge>}
              </Col>
            }
          >
            {allNotifications.map((eachNotification) => (
              <Menu.Item key={eachNotification.id}>
                <Row>
                  <Col>
                    <Typography.Paragraph>
                      {eachNotification.text}
                    </Typography.Paragraph>
                  </Col>
                  <Col style={{ marginLeft: "1vh" }}>
                    <Typography.Paragraph style={{ color: "#868B8E" }}>
                      {formattedDate(eachNotification.createdDate)}
                    </Typography.Paragraph>
                  </Col>
                </Row>
              </Menu.Item>
            ))}
            <Menu.Item>
              <Row justify="center">
                <StyledLink onClick={goToPage}>Show All</StyledLink>
              </Row>
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      ) : (
        <Menu mode="horizontal" style={{ border: "none" }}>
          <Menu.SubMenu
            title={
              <Badge count={unReadTotal}>
                <BsBell />
              </Badge>
            }
          ></Menu.SubMenu>
        </Menu>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getClientDetails: () => dispatch(getClientPersonalDetails()),
    getUserDetails: () => dispatch(getUserDetails()),
    getConsultantDetails: () => dispatch(getConsultantPersonalInfo()),
    logOut: () => dispatch(userReducer.signOut()),
    getAllNotifications: (page) =>
      dispatch(userReducer.getAllNotifications(page)),
    readAllNotifications: () => dispatch(userReducer.readAllNotifications()),
  };
};

export default connect(null, mapDispatchToProps)(Header);
